// const {
//   socketCall,
//   create,
//   modify,
//   remove
// } = require("./_utils");

module.exports = {
  // create: (data) => create("backend", data, "create"),
  // modify: (data) => modify("backend", data, "modify"),
  // remove: (uid) => remove("backend", uid, "remove"),
  // draft: (repositoryUid) => socketCall("admin", "backend.draft", {
  //   repositoryUid
  // })
}
